import { client } from "./client";
import interceptors from "./interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getTransactionData(params) {
    return client.get("tunnel/api/pos/report/transaction_data", {
        params: params,
    });
}

function getRegisterData(params) {
    return client.get("tunnel/api/pos/report/register-data", {
        params: params,
    });
}

function getTransactionDetail(params) {
    return client.get("tunnel/api/pos/report/transaction_detail", {
        params: params,
    });
}

function getSalesReport(params) {
    return client.get("tunnel/api/pos/report/sales_report", {
        params: params,
    });
}

function getSalesAnalysis(params) {
    return client.get("tunnel/api/pos/report/sales_analysis", {
        params: params,
    });
}


export default {
    getTransactionData,
    getTransactionDetail,
    getRegisterData,
    getSalesReport,
    getSalesAnalysis
};